import api from '@pray/shared/utils/api';

export type EmailHealthLeaderItem = {
  org_id: string;
  org_name: string;
  integration_type: string;
  integration_label: string | null;
  integration_image_url: string | null;
  status: 'supported' | 'unsupported' | 'error';
  grade: 'A' | 'B' | 'C' | 'D' | 'F' | null;
  open_rate: number | null;
  click_rate: number | null;
  complaint_rate: number | null;
  bounce_rate: number | null;
  list_size: number | null;
  last_refreshed: string | null;
  error_message: string | null;
};

export type EmailHealthLeadersSummary = {
  total: number;
  healthy: number;
  warning: number;
  critical: number;
};

export type EmailHealthLeadersResponse = {
  leaders: EmailHealthLeaderItem[];
  summary: EmailHealthLeadersSummary;
};

export async function getEmailHealthLeaders(): Promise<EmailHealthLeadersResponse> {
  const url = '/web/studio/email-health/leaders';
  const response = await api.executeGetRequest<{ data: EmailHealthLeadersResponse }>(url);

  return response.data.data;
}
